<template>
  <div>
    <b-row v-if="!_.isEmpty(errors)" no-gutters>
      <b-col>
        <response :items="errors"></response>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    code: null
  },
  data () {
    return {
      errors: []
    }
  },
  methods: {
    ...mapActions({
      user: 'auth/getForgotDataByCode'
    })
  },
  mounted () {
    let parent = this
    const code = this.$route.params.code
    this.user(code).then((response) => {
      this.$router.push({name: `Forgot.Step3.${this.$i18n.i18next.language}`})
    }).catch((error) => {
      parent.errors = error.response.data.errors
      if (error.response.status === 404) {
        // this.$router.push({name: `Forgot.Step1.${this.$i18n.i18next.language}`})
      }
    })
  }
}
</script>
